module.exports = __webpack_public_path__ + "assets/fonts/DK-Hand.2ceac480.ttf";